import {
  VersicherungsangabenConfig,
  VersicherungsangabenSectionConfig,
} from '@/features/Versicherungsangaben/types';
import { SECTION } from '@/components/layout/types';
import { beitragsReduzierungSection } from '@/features/Sparten/unf/formConfigs/inputFormConfig';

const inputConfig: VersicherungsangabenSectionConfig = {
  [SECTION.INPUT_VN]: {
    label: 'Angaben zum Versicherungsnehmer',
    component: () =>
      import(
        '@/features/Sparten/unf/sections/input/InputVersicherungsnehmer.vue'
      ),
  },
  [SECTION.INPUT_VP]: {
    label: 'Angaben zur versicherten Personen',
    component: () =>
      import(
        '@/features/Sparten/unf/sections/input/InputVersichertePersonen.vue'
      ),
  },
  [SECTION.INPUT_ABSICHERUNG]: {
    label: 'Gewünschte Absicherung',
    component: () =>
      import('@/features/Sparten/unf/sections/input/InputAbsicherung.vue'),
  },
  [SECTION.INPUT_BEITRAGSREDUZIERUNG]: {
    label: 'Mögliche Beitragsreduzierung',
    disabledPaths: ['demvRabattiert'],
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/input/InputBeitragsreduzierung.vue'
      ),
    componentProps: {
      'form-config': beitragsReduzierungSection,
    },
  },
};

const contractConfig: VersicherungsangabenSectionConfig = {
  [SECTION.CONTRACT_CLIENT]: {
    label: 'Persönliche Angaben',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractClient.vue'
      ),
  },
  [SECTION.UNF_CONTRACT_VP_INPUT]: {
    label: 'Persönliche Angaben zu versicherten Personen',
    requiresContractTariff: true,
    component: () =>
      import(
        '@/features/Sparten/unf/sections/contract/ContractVersichertePersonen.vue'
      ),
  },
  // [SECTION.CONTRACT_COMPANY_QUESTION]: {
  //   label: 'Gesellschaftsfragen',
  //   requiresContractTariff: true,
  //   component: () =>
  //     import(
  //       '@/features/Sparten/unf/sections/contract/ContractCompanyQuestions.vue'
  //     ),
  // },
  [SECTION.PROPERTY_CONTRACT_PREVIOUS_INSURANCE]: {
    label: 'Vorversicherung',
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractPreviousInsuranceAndDamage.vue'
      ),
  },
  [SECTION.UNF_ADDITIONAL_INSURANCE]: {
    label: 'Zusätzliche Versicherung',
    component: () =>
      import(
        '@/features/Sparten/unf/sections/contract/ContractAdditionalInsurance.vue'
      ),
  },
  [SECTION.CONTRACT_BANK_TRANSFER_INFORMATION]: {
    label: 'Zahlungsinformation',
    requiresContractTariff: true,
    component: () =>
      import(
        '@/features/Sparten/shared/sections/property/contract/ContractBankTransferInformation.vue'
      ),
  },
};

export const unfVersicherungsangabenConfig: VersicherungsangabenConfig = {
  inputConfig,
  contractConfig,
};
